module.exports = __webpack_public_path__ + "static/media/protip-slide-3.4484dedf.jpg";